import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { DownloadModalComponent } from './components/download-modal/download-modal.component';
import { CommentInputSelectionComponent } from './components/comment-input-selection/comment-input-selection.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FlagConfirmationModalComponent } from './components/flag-confirmation-modal/flag-confirmation-modal.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { CommonModalComponent } from './components/common-modal/common-modal.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ShowProfileModalComponent } from './components/show-profile-modal/show-profile-modal.component';
import { DragSliderDirective } from './directives/drag-slider.directive';
import { laoderComponent } from './components/loader/laoder.component';
import{ alertPopupComponent } from './components/alertPopup/alertPopup.component'
import{ EmbeddedModalPopupComponent } from './components/embedded-modal-popup/embedded-modal-popup.component'
import { PasswordManagementComponent } from './components/password-management/password-management.component';
import { PrivacySettingsComponent } from './components/privacy-settings/privacy-settings.component';
import { BrandingModalComponent } from './components/branding-modal/branding-modal.component';
import { ThemeCustomizerModalComponent } from './components/theme-customizer-modal/theme-customizer-modal.component';
import { TangramSelectComponent } from './components/tangram-select/tangram-select.component';

@NgModule({
  declarations: [
    FeedbackComponent,
    DownloadModalComponent,
    CommentInputSelectionComponent,
    FlagConfirmationModalComponent,
    CommonModalComponent,
    ShowProfileModalComponent,
    DragSliderDirective,
    laoderComponent,
    alertPopupComponent,
    EmbeddedModalPopupComponent,
    PasswordManagementComponent,
    PrivacySettingsComponent,
    BrandingModalComponent,
    ThemeCustomizerModalComponent,
    TangramSelectComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    NgxCaptchaModule,
    ReactiveFormsModule,
    NgbModule,
    SlickCarouselModule,
    NgSelectModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    NgxCaptchaModule,
    FeedbackComponent,
    CommentInputSelectionComponent,
    DownloadModalComponent,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    CommonModalComponent,
    SlickCarouselModule,
    ShowProfileModalComponent,
    FlagConfirmationModalComponent,
    DragSliderDirective,
    laoderComponent,
    alertPopupComponent,
    EmbeddedModalPopupComponent,
    PasswordManagementComponent,
    PrivacySettingsComponent,
    BrandingModalComponent,
    ThemeCustomizerModalComponent,
    TangramSelectComponent,
  ],
  entryComponents: [
    DownloadModalComponent,
    FeedbackComponent,
    FlagConfirmationModalComponent,
    CommonModalComponent,
    ShowProfileModalComponent,
    EmbeddedModalPopupComponent,
    PrivacySettingsComponent,
    BrandingModalComponent,
    ThemeCustomizerModalComponent,
    alertPopupComponent,
  ],
  schemas: [
    NO_ERRORS_SCHEMA
  ]

})
export class SharedModule {
}
